import { Box, IconButton, Slider, Tooltip } from "@mui/material";
import { Waves } from "@mui/icons-material";
import waveformAlt from "../../svg/waveformAlt.svg";

export const WaveSpecSlider = ({ onChange, value }) => {
  const wavValue = 100 - (value || 0) * 100;

  const decreaseOpacity = () => {
    let newValue = (100 - wavValue + 10) / 100;
    if (newValue > 1) newValue = 1;
    onChange(newValue);
  };

  const increaseOpacity = () => {
    let newValue = (100 - wavValue - 10) / 100;
    if (newValue < 0.1) newValue = 0;
    onChange(newValue);
  };

  const handleChange = (v) => {
    if (v && v.target) {
      const newValue = (100 - v.target.value) / 100;
      onChange(newValue);
    }
  };

  return (
    <Box display="flex" alignItems="center" gap={1} width={1}>
      <Tooltip title="Decrease Opacity">
        <IconButton onClick={decreaseOpacity}>
          <img src={waveformAlt} height={24} width={24} alt="waveform" />
        </IconButton>
      </Tooltip>
      <Slider
        aria-label="Wave vs Spectrograph"
        max={100}
        min={0}
        size="small"
        step={1}
        value={wavValue}
        onChange={handleChange}
      />
      <Tooltip title="Increase Opacity">
        <IconButton onClick={increaseOpacity}>
          <Waves color="primary" height={24} width={24} />
        </IconButton>
      </Tooltip>
    </Box>
  );
};
